const colors = {
   cyan: {
      50: "#fafefe",
      700: '#6cb5b8'
   },
   blue: {
      100: "#e0f0f2",
   },
   lightBlue: {
      100: '#e5f1f8',
      200: '#c1e5fa',
      900: '#1b669d'
   },
   white: {
      50: ' rgba(255,255,255,0.5)'
   },
   orange: {
      50: '#f7f7f7'
   }
}
export default colors